type SwipeProgressIndicatorProps = {
  progress: number
  isVisible: boolean
}

export const SwipeProgressIndicator = ({ progress, isVisible }: SwipeProgressIndicatorProps) => {
  if (!isVisible || progress <= 0) {
    return null
  }

  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 pointer-events-none">
      <div className="bg-black/80 backdrop-blur-sm rounded-full px-6 py-3 shadow-lg border border-white/20">
        <div className="flex flex-col items-center gap-2 min-w-30">
          {/* テキスト表示 */}
          <span className="text-white text-sm font-medium">次のエピソード</span>

          {/* プログレスバー */}
          <div className="w-full bg-gray-700 rounded-full h-2 overflow-hidden">
            <div className="h-full bg-blue-500" style={{ width: `${Math.min(100, progress)}%` }} />
          </div>

          {/* パーセンテージ */}
          <span className="text-gray-300 text-xs">{Math.round(progress)}%</span>
        </div>
      </div>
    </div>
  )
}
